// Daily operations lists (V1-7-03). Dates are Asia/Riyadh business dates.
// Pending payments stay on each Booking's finance panel; this grouping does
// not invent a balance.

export interface DailyBooking {
  readonly id: string;
  readonly displayReference: string;
  readonly status: string;
  readonly start: string;
  readonly end: string;
  readonly stay: { readonly checkedOutAt: string | null } | null;
  readonly indicators: { readonly departureToday: boolean; readonly overstay: boolean };
}

export interface DailyMaintenance {
  readonly id: string;
  readonly unitNumber: string;
  readonly phase: string;
}

export interface DailyLists<TBooking, TMaintenance> {
  readonly arrivals: readonly TBooking[];
  readonly unsignedArrivals: readonly TBooking[];
  readonly departures: readonly TBooking[];
  readonly overstay: readonly TBooking[];
  readonly maintenanceOverdue: readonly TMaintenance[];
}

export function classifyDay<TBooking extends DailyBooking, TMaintenance extends DailyMaintenance>(
  bookings: readonly TBooking[],
  maintenance: readonly TMaintenance[],
  today: string,
): DailyLists<TBooking, TMaintenance> {
  return {
    arrivals: bookings.filter(
      (booking) =>
        (booking.status === 'RESERVED' || booking.status === 'ACTIVE') &&
        booking.start === today &&
        booking.stay === null,
    ),
    unsignedArrivals: bookings.filter((booking) => booking.status === 'RESERVED' && booking.start <= today),
    departures: bookings.filter((booking) => booking.indicators.departureToday && booking.stay?.checkedOutAt == null),
    overstay: bookings.filter((booking) => booking.indicators.overstay && booking.stay?.checkedOutAt == null),
    maintenanceOverdue: maintenance.filter((item) => item.phase === 'overdue'),
  };
}
